import React, {useContext, useState} from 'react';
import useBoolean from "../../../../hooks/useBoolean";
import classNames from 'classnames';
import TideEntitySelect from "../../../../components/TideEntitySelect/TideEntitySelect";
import {NotifierContext} from "../../../../utils/Notifier";
import {TideApiContext} from "../../../../api/tideApiConfig";
import {getInventoryReportDownloadUrl} from "../../../../utils/modelUtils/almazen/inventoryUtils";

const InventoryExport = () => {

    const api = useContext(TideApiContext);
    const notifier = useContext(NotifierContext);
    const [isOpen,,,toggleOpen] = useBoolean();
    const [warehouse, setWarehouse] = useState();

    const handleClick = (e)=>{
        if(!warehouse){
            e.preventDefault();
            notifier.error('Llena todos los filtros');
        }
    };

    let link = "#";
    if(warehouse){
        link = getInventoryReportDownloadUrl(api, { warehouse: warehouse.id, 'order[productBrand.product.name]':'ASC' }, warehouse.name);
    }

    return (
        <div className={classNames("report-block", isOpen&&'open')}>
            <p className='title' onClick={toggleOpen}>Inventario actual de almacén <i className='fa fa-caret-down caret-icon'/></p>
            {isOpen&&
            <div className='body'>
                <hr/>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <p className='filter-label'>Almacén:</p>
                            <TideEntitySelect
                                entity='warehouses'
                                value={warehouse}
                                onChange={setWarehouse}
                            />
                        </div>
                        <div className='col-md-6'>
                            <p className='filter-label'>Descripción:</p>
                            <p className='description'>Exporta el inventario actual de todos los productos de un almacén.</p>
                        </div>
                    </div>
                </div>
                <br/>
                <a href={link} target='_blank' rel='noopener noreferrer' onClick={handleClick}>
                    <button className='btn btn-info'>Descargar</button>
                </a>

            </div>}
        </div>
    );
};

export default InventoryExport;
